import { useTranslation } from '@/hooks/useTranslation'
import { Box, Button, Stack, Typography } from '@mui/material'
import ErrorImage from 'components/images/404Image.png'
import { useNavigate } from 'react-router-dom'
import classes from './styles.module.scss'

const NotFound = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleBack = () => {
    navigate('/admin/interface')
  }

  return (
    <Stack className={classes.root}>
      <Box className={classes.container_header}>
        <Stack className={classes.content}>
          <Stack width="100%" justifyContent="center" alignItems="center">
            <img
              src={ErrorImage}
              alt="No img"
              style={{
                width: '100%',
                height: 'auto',
              }}
            />
            <Typography className={classes.txtNotFound}>
              {t('errorsPagesPageNotFoundTitle')}
            </Typography>
            <Typography className={classes.txtContent}>
              {t('errorsPagesPageNotFoundDescription')}
            </Typography>
            <Stack justifyContent="center" alignItems="center">
              <Button className={classes.btnBack} onClick={handleBack}>
                {t('commonActionsGoBack')}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  )
}

export default NotFound
